module.exports = __webpack_public_path__ + "img/card-self4.b17cc77b.svg";